import { Dispatch, Action, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import { SalesActivityModuleState } from "../../..";

export enum VendorComissionsActionTypes {
	SHOW_VENDOR_COMISSIONS_LOADER = "SHOW_VENDOR_COMISSIONS_LOADER",
	HIDE_VENDOR_COMISSIONS_LOADER = "HIDE_VENDOR_COMISSIONS_LOADER",
	OPEN_EDIT_VENDOR_COMISSIONS_DRAWER = "OPEN_EDIT_VENDOR_COMISSIONS_DRAWER",
	CLOSE_EDIT_VENDOR_COMISSIONS_DRAWER = "CLOSE_EDIT_VENDOR_COMISSIONS_DRAWER"
}

export type ShowVendorComissionLoaderAction =
	Action<VendorComissionsActionTypes.SHOW_VENDOR_COMISSIONS_LOADER>;
export type HideVendorComissionLoaderAction =
	Action<VendorComissionsActionTypes.HIDE_VENDOR_COMISSIONS_LOADER>;

export type OpenEditVendorComissionDrawerAction =
	Action<VendorComissionsActionTypes.OPEN_EDIT_VENDOR_COMISSIONS_DRAWER>;
export type CloseEditVendorComissionDrawerAction =
	Action<VendorComissionsActionTypes.CLOSE_EDIT_VENDOR_COMISSIONS_DRAWER>;

export type VendorComissionsActions =
	| ShowVendorComissionLoaderAction
	| HideVendorComissionLoaderAction
	| OpenEditVendorComissionDrawerAction
	| CloseEditVendorComissionDrawerAction;

export interface VendorComissionDispatch {
	showVendorComissionLoader: ActionCreator<
		ThunkAction<
			ShowVendorComissionLoaderAction,
			SalesActivityModuleState,
			null,
			ShowVendorComissionLoaderAction
		>
	>;
	hideVendorComissionLoader: ActionCreator<
		ThunkAction<
			HideVendorComissionLoaderAction,
			SalesActivityModuleState,
			null,
			HideVendorComissionLoaderAction
		>
	>;
	openEditVendorComissionDrawer: ActionCreator<
		ThunkAction<
			OpenEditVendorComissionDrawerAction,
			SalesActivityModuleState,
			null,
			OpenEditVendorComissionDrawerAction
		>
	>;
	closeEditVendorComissionDrawer: ActionCreator<
		ThunkAction<
			CloseEditVendorComissionDrawerAction,
			SalesActivityModuleState,
			null,
			CloseEditVendorComissionDrawerAction
		>
	>;
}

export const VendorComissionActionCreators: VendorComissionDispatch = {
	showVendorComissionLoader: () => {
		return (dispatch: Dispatch): ShowVendorComissionLoaderAction => {
			const showVendorOpportunityLoaderAction: ShowVendorComissionLoaderAction =
				{
					type: VendorComissionsActionTypes.SHOW_VENDOR_COMISSIONS_LOADER
				};
			return dispatch(showVendorOpportunityLoaderAction);
		};
	},
	hideVendorComissionLoader: () => {
		return (dispatch: Dispatch): HideVendorComissionLoaderAction => {
			const hideVendorOpportunityLoaderAction: HideVendorComissionLoaderAction =
				{
					type: VendorComissionsActionTypes.HIDE_VENDOR_COMISSIONS_LOADER
				};
			return dispatch(hideVendorOpportunityLoaderAction);
		};
	},
	openEditVendorComissionDrawer: () => {
		return (dispatch: Dispatch): OpenEditVendorComissionDrawerAction => {
			const openOpportunityDrawerAction: OpenEditVendorComissionDrawerAction =
				{
					type: VendorComissionsActionTypes.OPEN_EDIT_VENDOR_COMISSIONS_DRAWER
				};
			return dispatch(openOpportunityDrawerAction);
		};
	},
	closeEditVendorComissionDrawer: () => {
		return (dispatch: Dispatch): CloseEditVendorComissionDrawerAction => {
			const closeOpportunityDrawerAction: CloseEditVendorComissionDrawerAction =
				{
					type: VendorComissionsActionTypes.CLOSE_EDIT_VENDOR_COMISSIONS_DRAWER
				};
			return dispatch(closeOpportunityDrawerAction);
		};
	}
};

export default VendorComissionActionCreators;
